/**
 * 2007-2016 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2016 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import 'velocity-animate';
import StSideBar from './components/st-side-bar';
import Cookies from 'js-cookie';
/*import 'waypoints/lib/jquery.waypoints.js';
import 'waypoints/lib/shortcuts/sticky.js';
import ProductMinitature from './components/product-miniature';*/

$(document).ready(() => {
  var watch_quick_view = false;
  prestashop.on('clickQuickView', function (elm) {
    if(watch_quick_view || $('body').hasClass('product'))//disable quick view on product page cause when chaning attributes, codes like $('.product-prices') in core/product would get dom form both the product page he quickview
      return false;
    watch_quick_view = true;
    $('.quick_view_'+elm.dataset.idProduct).addClass('active'); //no way to get target because the code in code/listing do not pass it, so add active to all
    let data = {
      'action': 'quickview',
      'id_product': elm.dataset.idProduct,
      'id_product_attribute': elm.dataset.idProductAttribute,
    };
    $.post(prestashop.urls.pages.product, data, null, 'json').then(function (resp) {
      let quickview_id = `#quickview-modal-${resp.product.id}-${resp.product.id_product_attribute}`;
      $(quickview_id).remove();//just in case
      $('body').append(resp.quickview_html);
      let productModal = $(quickview_id);
      productModal.modal('show');
      productConfig(productModal);
      productModal.on('hidden.bs.modal', function () {
        productModal.remove();
      });
      productModal.on('shown.bs.modal', function (e) {
        prestashop.emit('quickViewLoaded', {
            quickview_id: quickview_id
        });
        watch_quick_view = false;
        $('.quick_view_'+elm.dataset.idProduct).removeClass('active');
      });
    }).fail((resp) => {
      prestashop.emit('handleError', {eventType: 'clickQuickView', resp: resp});
      watch_quick_view = false;
      $('.quick_view_'+elm.dataset.idProduct).removeClass('active');
    });
  });

  var productConfig = (qv) => {
    /*const MAX_THUMBS = 4;
    var $arrows = $('.js-arrows');
    var $thumbnails = qv.find('.js-qv-product-images');
    $('.js-thumb').on('click', (event) => {
      if ($('.js-thumb').hasClass('selected')) {
        $('.js-thumb').removeClass('selected');
      }
      $(event.currentTarget).addClass('selected');
      $('.js-qv-product-cover').attr('src', $(event.target).data('image-large-src'));
    });
    if ($thumbnails.find('li').length <= MAX_THUMBS) {
      $arrows.hide();
    } else {
      $arrows.on('click', (event) => {
        if ($(event.target).hasClass('arrow-up') && $('.js-qv-product-images').position().top < 0) {
          move('up');
          $('.arrow-down').css('opacity', '1');
        } else if ($(event.target).hasClass('arrow-down') && $thumbnails.position().top + $thumbnails.height() > $('.js-qv-mask').height()) {
          move('down');
          $('.arrow-up').css('opacity', '1');
        }
      });
    }*/
    qv.find('#quantity_wanted').TouchSpin({
      // verticalbuttons: !sttheme.is_mobile_device,
      verticalupclass: 'fto-plus-2',
      verticaldownclass: 'fto-minus',
      buttondown_class: 'btn btn-touchspin js-touchspin',
      buttonup_class: 'btn btn-touchspin js-touchspin',
      min: 1,
      max: 1000000
    });
  };
  /*var move = (direction) => {
    const THUMB_MARGIN = 20;
    var $thumbnails = $('.js-qv-product-images');
    var thumbHeight = $('.js-qv-product-images li img').height() + THUMB_MARGIN;
    var currentPosition = $thumbnails.position().top;
    $thumbnails.velocity({
      translateY: (direction === 'up') ? currentPosition + thumbHeight : currentPosition - thumbHeight
    }, function () {
      if ($thumbnails.position().top >= 0) {
        $('.arrow-up').css('opacity', '.2');
      } else if ($thumbnails.position().top + $thumbnails.height() <= $('.js-qv-mask').height()) {
        $('.arrow-down').css('opacity', '.2');
      }
    });
  };*/

  /*$('body').on('click', '#search_filter_toggler', function () {
    $('#search_filters_wrapper').removeClass('hidden-sm-down');
    $('#content-wrapper').addClass('hidden-sm-down');
    $('#footer').addClass('hidden-sm-down');
  });
  $('#search_filter_controls .clear').on('click', function () {
    $('#search_filters_wrapper').addClass('hidden-sm-down');
    $('#content-wrapper').removeClass('hidden-sm-down');
    $('#footer').removeClass('hidden-sm-down');
  });
  $('#search_filter_controls .ok').on('click', function () {
    $('#search_filters_wrapper').addClass('hidden-sm-down');
    $('#content-wrapper').removeClass('hidden-sm-down');
    $('#footer').removeClass('hidden-sm-down');
  });*/
  let stSideBar = new StSideBar();
  $('#search_filter_controls .ok').on('click', function () {
    stSideBar.resetSlidebar();
  });  

  const parseSearchUrl = function (event) {
    if (event.target.dataset.searchUrl !== undefined) {
      return event.target.dataset.searchUrl;
    }

    if ($(event.target).parent()[0].dataset.searchUrl === undefined) {
      throw new Error('Can not parse search URL');
    }

    return $(event.target).parent()[0].dataset.searchUrl;
  };


  var facets_watcher = false;//do one qurey at a time, in future hope PS using promises to do the latest query.
  $('body').on('change', '#search_filters input[data-search-url]', function (event) {
    if(guanli_watcher())
    {
      $(this).prop('checked', false);
      return false;
    }

    $(event.target).closest('.facet-label').addClass('loading');
    prestashop.emit('updateFacets', parseSearchUrl(event));
  });

  $('body').on('click', '.js-search-filters-clear-all', function (event) {    
    event.preventDefault();

    if(guanli_watcher())
      return false;

    prestashop.emit('updateFacets', parseSearchUrl(event));
  });

  $('body').on('click', '.js-search-link', function (event) {
    event.preventDefault();

    if(guanli_watcher())
      return false;

    prestashop.emit('updateFacets',$(event.target).closest('.facet-label').addClass('loading').end().closest('a').attr('href'));
  });

  $('body').on('change', '#search_filters select', function (event) {
    if(guanli_watcher())
      return false;

    const form = $(event.target).closest('form');
    prestashop.emit('updateFacets', '?' + form.serialize());
  });

  
  prestashop.on('updateProductList', (data) => {
    facets_watcher=false;
    updateProductListDOM(data);
  });

  function guanli_watcher(){
    if(facets_watcher)
      return facets_watcher;
    else
    {
      facets_watcher = true;
      return false;
    }
  }


  $('body').on('click', '.list_grid_switcher div', function (event) {
    event.preventDefault();
    $(this).addClass('selected').siblings().removeClass('selected');
    viewSwitcher($(this).hasClass('grid') ? 'grid' : 'list');
    var tm_gallery_dom = $('#js-product-list .tm_gallery');
    if(tm_gallery_dom.length){
      $.each(tm_gallery_dom,function(){
        if(typeof this.swiper !== 'undefined')
        {
          this.swiper.update(true);
          //also theme.js update_pro_img_swiper_buttons()
          if($(this.swiper.slides).length==$(this.swiper.slides).filter('.swiper-slide-visible').length)
          {
              $(this.swiper.params.nextButton).hide();
              $(this.swiper.params.prevButton).hide();
          }
          else
          {
              $(this.swiper.params.nextButton).show();
              $(this.swiper.params.prevButton).show();
          }
        }
      });
    }
  });
  
});

function viewSwitcher(view)
{
  Cookies.set("st_list_grid", view, {'domain': sttheme.cookie_domain,'path': sttheme.cookie_path});
  if (view == 'list')
  {
    var classnames = $('.products.product_list').removeClass('grid row').addClass('list').data('classnames');
    $('.product_list .product_list_item').removeClass(classnames).addClass('clearfix');
  }
  else 
  {
    var classnames = $('.products.product_list').removeClass('list').addClass('grid row').data('classnames');
    $('.product_list .product_list_item').removeClass('clearfix').addClass(classnames);
  } 
}
function updateProductListDOM (data) {
  $('#search_filters').replaceWith(data.rendered_facets);
  $('#js-active-search-filters').replaceWith(data.rendered_active_filters);
  $('#js-product-list-top').replaceWith(data.rendered_products_top);
  $('#js-product-list').replaceWith(data.rendered_products);
  $('#js-product-list-bottom').replaceWith(data.rendered_products_bottom);
  // let productMinitature = new ProductMinitature();
  // productMinitature.init();
  prestashop.emit('updatedProductListDOM');
}



// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js


// WEBPACK FOOTER //
// ./js/listing.js